import { Text, View } from "@react-pdf/renderer";
import i18n from "../../i18n";
import { NumberFormatTextPDF } from "../NumberFormatText";
import { tableDataTableStyles } from "./DataTable";

export function DataTableDataRowGroup({ index, tableInput, tableCalculated }) {
  let decimalSeparator = i18n.resolvedLanguage === "de-DE" ? "," : ".";
  let thousandSeparator = i18n.resolvedLanguage === "de-DE" ? "." : ",";
  return (
    <View style={tableDataTableStyles.row} key={index}>
      {/* Title */}
      <Text style={tableDataTableStyles.title}>{tableInput[index].schichtName}</Text>
      {/* von */}
      <Text style={tableDataTableStyles.title}>
        <NumberFormatTextPDF
          value={tableInput[index].von}
          decimalScale={2}
          decimalSeparator={decimalSeparator}
          thousandSeparator={thousandSeparator}
        />
      </Text>
      {/* bis */}
      <Text style={tableDataTableStyles.title}>
        <NumberFormatTextPDF
          value={tableInput[index].bis}
          decimalScale={2}
          prefix={"INF"}
          decimalSeparator={decimalSeparator}
          thousandSeparator={thousandSeparator}
        />
      </Text>
      {/* qsk */}
      <Text style={tableDataTableStyles.title}>
        <NumberFormatTextPDF
          value={tableInput[index].qski}
          // decimalScale={2}
          decimalSeparator={decimalSeparator}
          thousandSeparator={thousandSeparator}
        />
      </Text>
      {/* rdi */}
      <Text style={tableDataTableStyles.title}>
        <NumberFormatTextPDF
          value={tableCalculated[index]?.rdi}
          decimalScale={2}
          decimalSeparator={decimalSeparator}
          thousandSeparator={thousandSeparator}
        />
      </Text>
      {/* Lib */}
      <Text style={tableDataTableStyles.title}>
        <NumberFormatTextPDF
          value={tableCalculated[index]?.liZeta}
          decimalScale={2}
          decimalSeparator={decimalSeparator}
          thousandSeparator={thousandSeparator}
        />
      </Text>
      {/* rsdi */}
      <Text style={tableDataTableStyles.title}>
        <NumberFormatTextPDF
          value={tableCalculated[index]?.rsdi}
          decimalScale={0}
          decimalSeparator={decimalSeparator}
          thousandSeparator={thousandSeparator}
        />
      </Text>
    </View>
  );
}
